export default __webpack_public_path__ + "static/media/sam-man-tsai.303f0a51.jpg";